var exports = {
  "G1": "xfd349460--971bdf--expanded-container",
  "kL": "xfd349460--971bdf--container",
  "nf": "xfd349460--971bdf--link",
};

module.exports = exports;
